// Games/providers managed via dedicated pages that should not appear in
// casino lists, carousels, or any generic game surface.
export const HIDDEN_PROVIDERS = new Set(["centerhorsesv2__betconnect"]);

export const isVisibleGame = game =>
  !HIDDEN_PROVIDERS.has(game?.provider) && !HIDDEN_PROVIDERS.has(game?.game_provider);
